import { useEffect } from "react";
import { DISPLAY_CLOSE } from "src/pods/realtime/data/pairing";
import { subscribeToolkitReduxDispatches } from "src/state/toolkitReduxStore";
import {
  NoiseState,
  RECEIVE_MICROPHONE_PERMISSION_ERROR,
  RECEIVE_NOISE,
  SEND_MICROPHONE_PERMISSION_ERROR,
  SEND_NOISE,
} from ".";
import { toolkitNoiseActions } from "./toolkitNoiseStore";

export function useToolkitNoiseRuntime() {
  useEffect(() => {
    const unsubscribe = subscribeToolkitReduxDispatches((action) => {
      switch (action.type) {
        case SEND_NOISE:
        case RECEIVE_NOISE:
          toolkitNoiseActions.mergeNoise((action.payload ?? {}) as Partial<NoiseState>);
          break;

        case SEND_MICROPHONE_PERMISSION_ERROR:
        case RECEIVE_MICROPHONE_PERMISSION_ERROR:
          toolkitNoiseActions.mergeNoise({
            microphonePermissionErrorName:
              (action.payload as { errorName?: string | null })?.errorName ?? "NotAllowedError",
          });
          break;

        case DISPLAY_CLOSE:
          toolkitNoiseActions.resetMicrophonePermissionError();
          break;

        default:
          break;
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);
}
